





















































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { fetchClientStatus, fetchList } from './data'
import noconn from './img/black.png'
import VrClient from './util/VrClient/VrClient'
import preloadImage from './util/preloadImage/preloadImage'
import StudentLabel from '@/components/studyData/studentLabel.vue'
const _VrClient: any = VrClient
const _preloadImage: any = preloadImage
let client: any
@Component({
  components: {
    StudentLabel
  }
})
export default class PlayClass extends ViewBase {
  @Prop({ default: 0 }) classActive!: boolean

  lang: any = {}

  id: any = 0

  item: any = {}

  chapter: any = {}

  onlineList: any = []

  notOnlineList: any = []

  chapterList: any = []

  watchId: any = 0

  refreshTimer: any

  watchItem: any = {}

  visible: boolean = false

  client: any = null

  loading: boolean = true

  refreshView: boolean = false

  connectClient: boolean = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  itemFailClick(evt: any, item: any) {
    evt.stopPropagation()
    item.failCount = 0
    evt.target.style.display = 'none'
  }
  refreshStop() {
    clearInterval(this.refreshTimer)
  }
  closeWatch() {
    this.visible = false
    this.client.bye()
  }
  itemClick(item: any) {
    this.watchItem.name = item.name
    this.watchItem.item = item
    if (item.is_online == 1) {
      this.visible = true
    }
  }
  async initClient() {
    const { mqttAddress, commonTopic } = this.$store.state.clientParams
    this.client = client = new _VrClient(mqttAddress)
    try {
      await client.connect()
      client.topic = commonTopic
      client.send({ info: { type: 'start' } })
      this.connectClient = true
      this.refresh()
    } catch (ex) {
      // message.error(String(ex))
    }
  }
  refresh() {
    this.refreshStop()
    const { snapInterval } = this.$store.state.clientParams
    this.refreshTimer = setInterval(() => {
      this.onlineList.forEach(async (item: any, i: any) => {
        // 若当前正在查看某个设备的视频流，则不更新该设备的截图
        if (this.watchId == item.id) {
          return
        }

        // 如果已有 promise，则直接返回
        if (item._preloadPromise) {
          // console.log('-->>>> is await')
          return
        }
        if (!item.failCount) {
          item.failCount = 0
        }
        const failCount = item.failCount

        // 如果多次失败，就取消该项
        if (failCount > 3) {
          // console.log('-->>>> fail > 3 ', failCount)
          return
        }

        const rand = Math.random()
        const url = item.img.replace(/\?v=.*|$/, `?v=${rand}`)
        // item._preloadPromise && item._preloadPromise.cancel()
        item._preloadPromise = _preloadImage(url, { timeout: (failCount + 1) * 1000 })
        try {
          // console.log('-->>>> await preloadImage')
          const { src } = await item._preloadPromise
          const listEl: any = this.$refs.refList
          listEl && (listEl.querySelectorAll('img')[i].src = src)
          item.failCount = 0
        } catch (ex) {
          item.failCount++
          // console.log('-->>>> catch failCount ', item._failCount)
        } finally {
          // 重置，以便下次可以继续
          item._preloadPromise = null
        }
      })
    }, snapInterval)
  }
  async fetchViewList() {
    this.refreshView = false
    fetchList().then(res => {
      const {
        onlineList,
        not_login_student_list,
        mqtt_address,
        web_topic,
        client_common_topic,
        interval
      } = res
      this.$store.commit('setOnlineList', onlineList || [])
      this.$store.commit('setClientParams', {
        mqttAddress: mqtt_address,
        webTopic: web_topic,
        commonTopic: client_common_topic,
        snapInterval: interval
      })
      onlineList.forEach((item: any, index: number) => {
        if (!this.onlineList) {
          return
        }
        this.onlineList.forEach((oldItem: any, oldIndex: number) => {
          if (item.id == oldItem.id) {
            item.failCount = oldItem.failCount
          }
        })
      })
      this.onlineList = onlineList
      this.notOnlineList = not_login_student_list
      this.loading = false
      this.refreshView = true
      if (!this.connectClient) {
        this.initClient()
      }
    })
  }
  created() {
    this.watchItem.name = ''
    this.fetchViewList()
  }
  beforeDestroy() {
    client.close()
    this.refreshStop()
  }

  @Watch('refreshView')
  watchRefreshView(refresh: boolean) {
    if (refresh) {
      setTimeout(() => {
        this.fetchViewList()
      }, 3000)
    }
  }
  @Watch('visible')
  watchVisible(value: boolean) {
    if (value) {
      const { id, topic, client_id } = this.watchItem.item
      const { webTopic } = this.$store.state.clientParams
      setTimeout(() => {
        const video = this.$refs.refWatchVideo
        client.play({ topic, to: client_id, webTopic, video })
        this.watchId = id
      })
    } else {
      this.watchId = 0
    }
  }
  @Watch('classActive')
  watchClassActive(value: boolean) {
    if (!value) {
      client.close()
    }
  }
}
